import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62aca88b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, "\n        ペナルティは発生しません\n      ", -1))
const _hoisted_2 = { class: "header-close" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content-description" }, "\n        事業所で発生している感染症が理由のため、ペナルティは発生しません\n      ", -1))
const _hoisted_5 = {
  key: 0,
  class: "content-body-container"
}
const _hoisted_6 = { class: "content-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content-body--changed-label" }, "信用スコア", -1))
const _hoisted_8 = { class: "content-body--changed-body" }
const _hoisted_9 = { class: "current" }
const _hoisted_10 = { class: "current" }
const _hoisted_11 = { class: "content-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content-body--changed-label" }, "最大応募可能件数", -1))
const _hoisted_13 = { class: "content-body--changed-body" }
const _hoisted_14 = { class: "current" }
const _hoisted_15 = { class: "current" }
const _hoisted_16 = { class: "content-caution" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "0pt", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "応募済みのお仕事は全て自動でキャンセル", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content-caution notion" }, "一時的にお仕事へ応募不可", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "footer-actions" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-actions divider" }, null, -1))

import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { WorkerReliability } from "@/types/WorkerReliability";
import ExternalLink from "@/const/externalLink";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationsCancelDueToInfectionModal',
  props: {
  currentWorkerReliability: {
    type: Object as PropType<WorkerReliability>,
    required: true
  },
  noCloseOnBackdrop: {
    type: Boolean,
    default: false
  },
  noCloseOnEsc: {
    type: Boolean,
    default: false
  }
},
  emits: ["click-confirm", "click-close"],
  setup(__props, { emit: emits }) {





const ok = () => {
  emits("click-confirm");
};

const close = () => {
  emits("click-close");
};

return (_ctx: any,_cache: any) => {
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    id: "confirm-cancel-due-to-infection",
    centered: "",
    "dialog-class": "confirm-cancel-modal dialog",
    "content-class": "confirm-cancel-modal content try-cancel-modal",
    "body-class": "confirm-cancel-modal body",
    "header-class": "confirm-cancel-modal header-no-penalty suspend-info",
    "no-close-on-backdrop": __props.noCloseOnBackdrop,
    "no-close-on-esc": __props.noCloseOnEsc,
    onOk: ok,
    onClose: close
  }, {
    "modal-header": _withCtx(({ close }) => [
      _hoisted_1,
      _createTextVNode(),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(FeatherIcon, {
          icon: "x-circle",
          size: "24",
          onClick: close
        }, null, 8, ["onClick"])
      ])
    ]),
    "modal-footer": _withCtx(({ close, ok }) => [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_BButton, {
          block: "",
          variant: "outline-gray-04 text-primary-dark",
          onClick: close,
          class: "footer-actions button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ], undefined, true),
          _: 2
        }, 1032, ["onClick"]),
        _createTextVNode(),
        _hoisted_23,
        _createTextVNode(),
        _createVNode(_component_BButton, {
          block: "",
          variant: "blue text-white",
          onClick: ok,
          class: "footer-actions button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("了承する\n        ")
          ], undefined, true),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(),
        (__props.currentWorkerReliability)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(__props.currentWorkerReliability.creditScore) + " pt", 1),
                  _createTextVNode("\n            →\n            "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(__props.currentWorkerReliability.creditScore) + " pt", 1)
                ])
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(__props.currentWorkerReliability.applyLimit) + " 件", 1),
                  _createTextVNode("\n            →\n            "),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(__props.currentWorkerReliability.applyLimit) + " 件", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_16, [
          _createTextVNode("\n        信用スコアが"),
          _hoisted_17,
          _createTextVNode("になった場合、"),
          _hoisted_18,
          _createTextVNode("となり、"),
          _hoisted_19,
          _createTextVNode("となります。"),
          _hoisted_20,
          _createTextVNode("\n        詳細は"),
          _createElementVNode("a", {
            href: _unref(ExternalLink).CREDIT_SCORE_IS_ZERO_FAQ_URL,
            target: "_blank",
            class: "text-primary"
          }, "こちら", 8, _hoisted_21),
          _createTextVNode("をご覧ください。\n      ")
        ])
      ]),
      _createTextVNode()
    ], undefined, true),
    _: 1
  }, 8, ["no-close-on-backdrop", "no-close-on-esc"]))
}
}

})